import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
declare var $;
@Component({
  selector: 'app-selectdata',
  templateUrl: './selectdata.page.html',
  styleUrls: ['./selectdata.page.scss'],
})
export class SelectdataPage implements OnInit {

  plans: [];
  base_imgurl: any;
  price: any;
  price_for_meal: any;
  subtotal: any;
  discount: any;
  shipping: any; 
  plan_image: any;
  lastActivecarda: any;
  lastid:any;
  total:any;
  disc:any;
  maxam:any; 
  discaman:any;
 min:any;
 tax:any; 
 ch:any;


  constructor(public router: Router) {
    this.base_imgurl = localStorage.imgurl;
    this.lastActivecarda = 0;
    this.maxam = 0; 
    this.discaman = "0%" 
    this.min = 3;
    this.ch = 0;
  }

  ngOnInit() {
  }

  updateValues(){
    this.selectPlan(this.lastid,0);
  }

  welcome(){
    this.router.navigate(['/login']);
  }



  ionViewWillEnter() {
    localStorage.plan_name = "";

    setTimeout(()=>{
        $("#amofmelas").change(()=>{
        this.updateValues();
        })
    },500)
    $.getJSON(localStorage.apiurl, {
      op: "get_plans"
    }, (r) => {
      console.log(r);
      this.plans = r;
    })

  }

  check(){
    if ($('#alllu').is(":checked")){ 
      this.ch = 1;
      this.selectPlan(3,1);
    }else{
      this.ch = 0;
      this.selectPlan(3,0);
    }
  } 

  selectPlan(id_plan,forceten) {

    if(forceten == 0){
      $( "#alllu" ).prop( "checked", false );
      this.ch = 0; 
    }

    if(id_plan == 4){
      $( "#conal" ).hide();
    }else{
      $( "#conal" ).show();
    }
 


    this.lastid = id_plan;
    if (this.lastActivecarda == 0) {
      $(".yosoy" + id_plan).addClass("activecarda");
      this.lastActivecarda = id_plan;
    } else {
      if (id_plan == this.lastActivecarda) {

      } else {
        $(".yosoy" + this.lastActivecarda).removeClass("activecarda");
        $(".yosoy" + id_plan).addClass("activecarda");
        this.lastActivecarda = id_plan;
      }
    } 
    

    $.getJSON(localStorage.apiurl, {
      op: "detail_plans",
      id_plan: id_plan
    }, (r) => {
       //alert($("#amofmelas").val());
      var amofmelas = 0;
      var price_for_meal = r[0].price_for_meal;
      var shipping = r[0].shipping;
      var plan_name = r[0].plan_name;

      if(r[0].id_plan == 4){
        this.maxam = r[0].maxam;
        this.min = 2;
        setTimeout(()=>{
          amofmelas = $("#amofmelas").val()
  
          if( amofmelas == 4){
            this.discount = 0.05;
            this.discaman = "5%"
          }
          if( amofmelas > 4){
            this.discount = 0.10;
            this.discaman = "10%"
          }
          if( amofmelas < 4){
            this.discount = 0;
            this.discaman = "0%"
          }

          this.concealcalulation(id_plan,amofmelas,price_for_meal,shipping,plan_name,0);

        },500)
        

      }else{
        this.maxam = r[0].maxam;
        this.min = 8;
        setTimeout(()=>{
          amofmelas = $("#amofmelas").val();
  
          if( amofmelas > 8 &&  amofmelas < 12){
            this.discount = 0;
            this.discaman = "0%"
          }
          if( amofmelas > 11 &&  amofmelas < 15){
            this.discount = 0.05;
            this.discaman = "5%"
          }
          if(  amofmelas > 15){
            this.discount = 0.10;
            this.discaman = "10%"
          }
          if(forceten == 1){
            this.discount = 0.15;
            this.discaman = "15%"
          }
          this.concealcalulation(id_plan,amofmelas,price_for_meal,shipping,plan_name,forceten)
        },500)
      }
    })
  }

  counter(i: number) {
    return new Array(i);
}

concealcalulation(id_plan,amofmelas,price_for_meal,shipping,plan_name,forceten){

  this.price = price_for_meal;
  //this.price_for_meal = r[0].price_for_meal;
  this.subtotal = this.price * amofmelas ;

  //this.discount = r[0].discount;
  this.shipping = shipping

  if(this.discount > 0){
    this.disc = this.subtotal * this.discount
    this.disc = this.disc.toFixed(2);
    this.tax = this.subtotal * 0.8875; //por mientras
      this.total = +this.shipping + +this.subtotal - +this.disc + +this.tax;  
  }else{
    this.disc = 0;

    this.tax = this.subtotal * 0.08875; //por mientras
    this.total = +this.shipping + +this.subtotal + +this.tax 
  }
if(forceten == 1){
  this.total = this.total * 4
}

  localStorage.id_plan = id_plan;
  //localStorage.price:
  localStorage.total = this.total;
  localStorage.disc = this.disc;
  localStorage.shipping = this.shipping;
  localStorage.subtotal = this.subtotal;
  localStorage.plan_name = plan_name;
  localStorage.mealspermonth =  amofmelas;
  localStorage.tax = this.tax;

}



  continue() {
    if(localStorage.plan_name == ""){
      alert("Please select a plan.");
      return;
    }
    this.router.navigate(['/cart']);
  }
}
